// @flow
import {
  Home,
  Landing,
  SeasonTicket,
  LoginWall,
  ConsentsWall,
  Register,
  SearchResults,
  Checkout,
  AddListing,
  EditListing,
  VehiclePage,
  PaymentsPage,
  WithdrawalPage,
  UpdatePrompt,
  ParkingSpaces,
  Availability,
  PartnerCheckout,
  PartnerSearchResults,
  ProfilePage,
  BookingsMadePage,
  SeasonTicketsDashboardPage,
  BookingsDetailsPage,
  Agreements,
  Logout,
  Cancellation,
  Privacy,
  Terms,
  BookingReceivedPage,
  SeasonTicketDetailsPage,
  Insurance,
  ResetPassword,
  DeleteAccount,
  PartnerHelp,
  ListingPhotos,
  InsuranceWhileParkedWebview,
  BookingsReceived,
  Dashboard,
  Cookie,
  EvSignupPage,
  EvWelcomePage,
  EvEditPayment,
  EvListingChargerDetails,
  ListingDetailsPage,
  // SuperUserPage,
  ListingOnboardingPage
} from './pages/Pages';
import NotFound from './components/Common/NotFound';
import rootLandingLoader from './dataLoaders/landingRootLoader';

export default () => [
  {
    element: Home,
    path: '/',
    meta: {
      hideFindParking: true
    }
  },
  {
    element: Dashboard,
    path: '/dashboard'
  },
  {
    element: ConsentsWall,
    path: '/dashboard/profile/data-preferences/',
    strict: false
  },
  {
    element: Landing,
    loader: rootLandingLoader,
    path: '/:country/parking/:slug/*',
    strict: true,
    meta: {
      hideFindParking: true
    }
  },
  {
    element: LoginWall,
    path: '/auth/login',
    strict: false
  },
  {
    element: ConsentsWall,
    path: '/consent-wall',
    strict: false
  },
  {
    element: Register,
    path: '/registration',
    strict: false
  },
  {
    element: SearchResults,
    path: '/search/',
    meta: {
      routeType: 'search',
      hideFooter: true
    }
  },
  {
    element: PartnerSearchResults,
    path: '/partner/:partnerName/search/',
    exact: true,
    meta: {
      routeType: 'search',
      hideFooter: true
    }
  },
  {
    element: Checkout,
    path: '/checkout/:listingId',
    meta: {
      routeType: 'checkout',
      hideFooter: true
    }
  },
  {
    element: PartnerCheckout,
    path: '/partner/:partnerName/checkout/:listingId',
    meta: {
      routeType: 'checkout',
      hideFooter: true
    }
  },
  {
    element: SeasonTicket,
    path: '/season-tickets/:vendor',
    exact: true
  },
  {
    element: AddListing,
    path: '/dashboard/listings/add',
    meta: {
      headerHidePrimaryNav: true,
      headerMinimalBackground: true,
      headerDarkMobileMenu: true,
      hideFooter: true
    }
  },
  {
    element: ParkingSpaces,
    path: '/dashboard/parking-spaces',
    exact: true,
    meta: {
      headerMinimalBackground: true
    }
  },
  {
    element: EditListing,
    path: '/dashboard/listings/edit/:listingId',
    exact: true,
    meta: {
      headerHidePrimaryNav: true,
      headerMinimalBackground: true,
      headerDarkMobileMenu: true,
      hideFooter: true
    }
  },
  {
    element: UpdatePrompt,
    path: '/dashboard/listings/check/:id',
    exact: true,
    meta: {
      headerHidePrimaryNav: true,
      hideFooter: true,
      headerDarkMobileMenu: true
    }
  },
  {
    element: Availability,
    path: '/dashboard/parking-spaces/:listingId/availability/',
    state: {
      page: 'home'
    },
    meta: {
      headerHidePrimaryNav: true,
      headerMinimalBackground: true
    }
  },
  {
    element: ListingPhotos,
    path: '/dashboard/listings/edit/:listingId/photos/',
    meta: {
      headerMinimalBackground: true
    }
  },
  {
    element: VehiclePage,
    path: '/vehicles'
  },
  {
    element: PaymentsPage,
    path: '/dashboard/billing/payment-sources'
  },
  {
    element: WithdrawalPage,
    path: '/dashboard/billing/withdrawal',
    exact: true
  },
  {
    element: ProfilePage,
    path: '/dashboard/profile',
    exact: true
  },
  {
    element: BookingsMadePage,
    path: '/dashboard/bookings/',
    exact: true,
    children: [
      {
        element: BookingsMadePage,
        path: '/dashboard/bookings/made/'
      },
      ';;'
    ]
  },
  {
    element: InsuranceWhileParkedWebview,
    path: '/dashboard/bookings/made/:bookingId/insurance',
    exact: true,
    meta: {
      hideFooter: true
    }
  },
  {
    element: BookingsDetailsPage,
    path: '/dashboard/bookings/made/:bookingId',
    children: [
      {
        element: BookingsDetailsPage,
        path: '/dashboard/bookings/made/:bookingId/vehicle/change'
      },
      {
        element: BookingsDetailsPage,
        path: '/dashboard/bookings/made/:bookingId/driver-amendment'
      },
      {
        element: BookingsDetailsPage,
        path: '/dashboard/bookings/made/:bookingId/driver-cancellation'
      }
    ]
  },
  {
    element: BookingsDetailsPage,
    path: '/dashboard/feedback/leave-feedback/:bookingId'
  },
  {
    element: SeasonTicketsDashboardPage,
    path: '/dashboard/season-tickets/',
    exact: true
  },
  {
    element: SeasonTicketDetailsPage,
    path: '/dashboard/season-tickets/:id'
  },
  {
    element: Logout,
    path: '/auth/logout',
    exact: true
  },
  {
    element: Agreements,
    path: '/driver-agreement',
    exact: true
  },
  {
    element: Agreements,
    path: '/owner-agreement',
    exact: true
  },
  {
    element: Cancellation,
    path: '/cancellation-policy',
    exact: true
  },
  {
    element: Privacy,
    path: '/privacy-policy',
    exact: true
  },
  {
    element: Cookie,
    path: '/cookie-policy',
    exact: true
  },
  {
    element: Terms,
    path: '/terms-and-conditions',
    exact: true
  },
  {
    element: Insurance,
    path: '/insurance-policy',
    exact: true
  },
  {
    element: BookingsReceived,
    path: '/dashboard/bookings/received',
    exact: true
  },
  {
    element: BookingReceivedPage,
    path: '/dashboard/bookings/received/:bookingId',
    exact: true
  },
  {
    element: ResetPassword,
    path: '/password/reset/update',
    exact: true
  },
  {
    element: DeleteAccount,
    path: '/auth/consents/revoke',
    exact: true
  },
  {
    element: PartnerHelp,
    path: '/help',
    meta: {
      headerHidePrimaryNav: true,
      headerMinimalBackground: true
    }
  },
  {
    element: EvSignupPage,
    path: '/users/ev-signup',
    exact: true
  },
  {
    element: EvWelcomePage,
    path: '/users/ev-welcome',
    exact: true
  },
  {
    element: EvEditPayment,
    path: '/users/edit-ev-payment',
    exact: true
  },
  {
    element: EvListingChargerDetails,
    path: '/dashboard/listings/edit/:listingId/ev/',
    exact: true,
    meta: {
      headerHidePrimaryNav: true,
      headerMinimalBackground: true,
      headerDarkMobileMenu: true
    }
  },
  {
    element: ListingDetailsPage,
    path: '/:country/parking/:citySlug/s/:slug',
    strict: true,
    meta: {
      hideFindParking: true
    }
  },
  {
    element: BookingReceivedPage,
    path: '/dashboard/bookings/:bookingId/owner-cancellation/'
  },
  // {
  //   element: SuperUserPage,
  //   path: '/admin/su',
  //   strict: true
  // },
  {
    element: ListingOnboardingPage,
    path: '/dashboard/listing-onboarding',
    exact: true,
    meta: {
      hideHeader: true,
      hideFooter: true
    }
  },
  {
    path: '*',
    element: NotFound
  }
];
